<template>
  <div
    class="coupon-item j-select-coupon-item"
    :pointValue="
      fullReductType ? fullReductMoney + currency : discount + '%OFF'
    "
    v-if="!isEmpty"
    :class="{ active: active, invalid: invalid, hoverActive: showItemUseBtn }"
    @click="handleChooseCoupon"
  >
    <div class="left">
      <p class="coupon-item-tag">{{ tagText }}</p>
      <div class="coupon-item-type" v-if="fullReductLimitBottomMoney === 0">
        {{ letter.couponNoLimit }}
      </div>
      <div class="coupon-item-type" v-if="fullReductLimitBottomMoney > 0">
        {{
          letter.couponFuilCanUse
            .replace('${price}', fullReductLimitBottomMoney)
            .replace('${currency}', currency)
        }}
      </div>
      <p class="coupon-item-date">
        {{ letter.voucherValidTime }}:{{ localStartDate }} - {{ localEndDate }}
      </p>
      <p class="coupon-item-tip">{{ useLimitTip }}</p>
      <p class="coupon-item-tip">
        {{
          letter.voucherLimitRegion
            ? letter.voucherLimitRegion.replaceAll('${currency}', currency)
            : ''
        }}
      </p>
      <p class="coupon-item-tip" v-if="discountType && discountLimitTopMoney">
        ({{
          letter.couponMaxDiscount
            .replace('${price}', discountLimitTopMoney)
            .replace('${currency}', currency)
        }})
      </p>
      <p class="coupon-item-tip" v-if="hasUsed">
        {{ letter.couponHasUsed }}：{{ localUsedDate }}
      </p>
    </div>
    <div class="right">
      <div class="coupon-item-use">
        <p class="coupon-item-name" v-if="fullReductType">
          {{ fullReductMoney }}
          <span class="coupon-item-currency">{{ currency }}</span>
        </p>
        <p class="coupon-item-name" v-else>{{ discount }}%OFF</p>
        <div
          v-if="showItemUseBtn"
          class="coupon-item-use-btn j-click-coupon-item-use"
          :pointValue="
            fullReductType ? fullReductMoney + currency : discount + '%OFF'
          "
          href="javascript:;"
        >
          {{ letter.couponUseNow }}
        </div>
      </div>
      <div
        v-show="active"
        class="coupon-item-choose-ico iconfont icon-choose"
      ></div>
    </div>
  </div>
  <div class="coupon-item empty" :class="{ invalid: invalid }" v-else>
    <p class="coupon-item-empty-text">{{ letter.voucherLiuyi }}</p>
  </div>
</template>

<script type="text/javascript">
import coupon from '@mixins/officialWebStore/coupon';
import { times, couponLocalDateFormat } from '@utiles/officialStore';
export default {
  name: 'couponItem',
  props: ['info', 'active', 'invalid', 'isEmpty', 'showItemUseBtn'],
  mixins: [coupon],
  computed: {
    fullReductType() {
      return +this.info.TYPE === 0;
    },
    discountType() {
      return +this.info.TYPE === 1;
    },
    startDate() {
      return this.dateFormat(this.info.START_TIME);
    },
    endDate() {
      return this.dateFormat(this.info.EXPIRY_TIME);
    },
    lang() {
      return this.$store.state.lang;
    },
    localGetDate() {
      return couponLocalDateFormat(this.info.GET_TIME, this.lang);
    },
    localStartDate() {
      return couponLocalDateFormat(this.info.START_TIME, this.lang);
    },
    localEndDate() {
      return couponLocalDateFormat(this.info.EXPIRY_TIME, this.lang);
    },
    localUsedDate() {
      return couponLocalDateFormat(this.info.USE_TIME, this.lang);
    },
    currency() {
      return this.info?.CURRENCY || '';
    },
    fullReductLimitBottomMoney() {
      return +this.info.LIMIT_BOTTOM_MONEY || 0;
    },
    fullReductMoney() {
      return this.info.REDUCTION_MONEY || 0;
    },
    discount() {
      return times(+this.info.DISCOUNT, 100);
    },
    discountLimitTopMoney() {
      return +this.info.LIMIT_TOP_MONEY;
    },
    useLimitTip() {
      let tips = [];
      const productType = {
        coin: this.letter.couponOnlyCoinCanUse,
        package: this.letter.couponOnlyPackageCanUse,
        subscription: this.letter.couponOnlySubCanUse,
        currency: this.letter.couponOnlyDaibiCanUse
      };
      const hasPaytypeList =
        (this.info.PAY_TYPE_LIST && this.info.PAY_TYPE_LIST.length) || 0;
      const hasProductList =
        (this.info.PRODUCT_LIST && this.info.PRODUCT_LIST.length) || 0;
      const hasProductType = this.info.PRODUCT_TYPE || 0;

      if (hasProductType) {
        tips.push(productType[this.info.PRODUCT_TYPE]);
      }

      if (hasPaytypeList && hasProductList) {
        tips.push(this.letter.couponPartProductCanUse);
        tips.push(this.letter.couponPartPaytypeCanUse);
      } else if (hasPaytypeList && !hasProductList) {
        tips.push(this.letter.couponPartPaytypeCanUse);
      } else if (!hasPaytypeList && hasProductList) {
        tips.push(this.letter.couponPartProductCanUse);
      } else if (!hasPaytypeList && !hasProductList && !hasProductType) {
        tips.push(this.letter.couponAllProductCanUse);
      }

      return tips.join(';');
    },
    letter() {
      return this.$store.state.letter;
    },
    tagText() {
      if (this.info.DESCRIPTION) {
        return this.info.DESCRIPTION;
      }
      if (this.fullReductType) {
        return this.letter.couponReductionType;
      }
      if (this.discountType) {
        return this.letter.couponDiscountType;
      }
      return '';
    },
    hasUsed() {
      // -1 提单未支付 0 未使用 1 完成支付 2 回收
      return +this.info.STATE === 1 || +this.info.STATE === -1;
    }
  },
  methods: {
    dateFormat(time) {
      const t = new Date(+time * 1000);
      const formate = 'Y-M-D h:m';
      let year = t.getFullYear();
      let month = t.getMonth() + 1;
      let day = t.getDate();
      let hour = t.getHours();
      let minu = t.getMinutes();
      month = month > 9 ? month : `0${month}`;
      day = day > 9 ? day : `0${day}`;
      minu = minu == 0 ? '00' : minu;
      const hash = {
        Y: year,
        M: month,
        D: day,
        h: hour,
        m: minu
      };
      return formate.replace(/\w/g, i => {
        return hash[i];
      });
    },
    updateActiveCouponId() {
      window.webstorev2DataLayer.push({
        eventName: 'select_coupon',
        eventReason: 'click_select',
        eventValue: {
          coupon_typeid: this.info?.COUPON_TYPE || '',
          coupon_type_name: this.tagText || '',
          coupon_id: this.info?.COUPON_ID || '',
          coupon_start_time: this.info?.GET_TIME || '',
          coupon_end_time: this.info?.EXPIRY_TIME || '',
          coupon_local_money: this?.fullReductMoney || '',
          coupon_discount: this.info?.DISCOUNT || ''
        }
      });
      this.$emit('chooseCoupon', this.info.COUPON_ID);
    },
    handleChooseCoupon() {
      if (this.showItemUseBtn) {
        this.updateActiveCouponId();
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialWebStore/officialWebStore.scss';
.coupon-item {
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  margin-bottom: 30px;
  width: 100%;
  font-size: 22px;
  border-radius: 10px;
  box-shadow: 0px 0px 10px 0px rgb(217, 217, 217);
  background: #fff;

  &.hoverActive {
    cursor: pointer;
    @include g-border(2px);
  }
  .left {
    color: #333;
    width: 452px;
    padding: 30px 20px;
  }
  .right {
    position: relative;
    width: 218px;
  }
  &-choose-ico {
    position: absolute;
    right: 5px;
    bottom: 3px;
    font-size: 40px;
    color: #fff;
  }
  &-name {
    font-size: 30px;
    color: #fff;
    text-align: center;
  }
  &-tag {
    font-size: 24px;
    margin-bottom: 20px;
  }
  &-type {
    display: inline-block;
    margin-bottom: 20px;
    padding: 0 10px;
    text-align: center;
    font-size: 20px;
    color: $btnBg;
    border-radius: 9px;
    height: 27px;
    line-height: 27px;
    border: 1px solid $btnBg;
  }
  &-date {
    margin-bottom: 20px;
    line-height: 25px;
  }
  &-tip {
    color: #999;
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  &-use {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    @include g-gradient-btn();
    &-btn {
      display: inline-block;
      text-align: center;
      cursor: pointer;
      font-size: 22px;
      color: #333;
      border-radius: 30px;
      background: #fff;
      padding: 15px 20px;
      align-self: center;
      margin-top: 29px;
      &:hover {
        color: $btnBg;
      }
    }
  }
  &-empty-text {
    text-align: center;
  }
  // &.active {
  //   border: 2px solid $borderActive;
  // }
  &.invalid {
    .coupon-item-use {
      background-image: linear-gradient(to right, #eae1d8, #bcb3a8);
    }
  }
  &.empty {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 325px;
  }
}
@media screen and (orientation: landscape) {
  .coupon-item {
    font-size: 16px;
    margin-bottom: 10px;
    .left {
      padding: 20px;
    }
    &-tag {
      font-size: 22px;
      margin-bottom: 10px;
    }
    &-date {
      margin-bottom: 10px;
    }
    &-tip {
      margin-bottom: 10px;
    }
    &-type {
      font-size: 16px;
      margin-bottom: 10px;
    }
  }
}
</style>
